
    (function () {
      var ACCESS_KEY   = 'udwdevtest';         // shared secret in URL
      var PARAM_NAME   = 'token';             // ?token=phxaccess
      var STORAGE_KEY  = 'udwdevtest_has_access';    // localStorage flag
      var FALLBACK_URL = 'https://udw.ie';

      // Let you edit in the Shopify theme editor without being booted
      if (window.Shopify && Shopify.designMode) {
        document.documentElement.style.visibility = 'visible';
        return;
      }

      try {
        var u = new URL(window.location.href);
        var token = u.searchParams.get(PARAM_NAME);

        // Optional: quick test switch to clear access (append ?clearAccess=1)
        if (u.searchParams.get('clearAccess') === '1') {
          try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
        }

        // If token matches, grant access and remove it from the URL
        if (token === ACCESS_KEY) {
          try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
          u.searchParams.delete(PARAM_NAME);
          // keep any other params/hash
          var clean = u.pathname + (u.search ? '?' + u.searchParams.toString() : '') + u.hash;
          window.history.replaceState({}, '', clean);
        }

        // If not granted yet, bounce to Google
        var granted = false;
        try { granted = localStorage.getItem(STORAGE_KEY) === '1'; } catch (e) {}
        if (!granted) {
          // (If you don't want Google to see the referrer, add:
          // <meta name="referrer" content="no-referrer"> in <head>)
          window.location.replace(FALLBACK_URL);
          return;
        }

        // Show the page
        document.documentElement.style.visibility = 'visible';
      } catch (e) {
        // If anything goes sideways, fail closed
        window.location.replace(FALLBACK_URL);
      }
    })();
 